import React , {useState , useEffect} from 'react';
import ReactDOM from "react-dom";

import axios from 'axios';

import FlexContainer from 'react-styled-flexbox';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { borders } from '@material-ui/system';
import flexbox from '@material-ui/system';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

const titleStyle = {
fontWeight: 'bold',
color: '#6D5C1C',
fontSize: '18px'
}

const title1Style = {
fontWeight: 'bold',
fontSize: '16px'
}


function LoadDir() {
  const [dirm , setDirm] = useState([]);
  const [isLoading , setIsLoading] = useState(false);
  const [isError , setIsError] = useState(false);

  useEffect(() => {
      async function fetchBoard()  {
         setIsError(false);
         setIsLoading(true);
      try {
        const result = await axios.post("php/dir_extract.php");
         setDirm(result.data);
      } catch(error) {
          setIsError(true);
          console.log("YUK_DIR");
          console.log(error);
      }
        setIsLoading(false);
     };
      fetchBoard();
    }, []);



  return (
    <React.Fragment>
     {isLoading ?(<div> Loading ....</div> ):(
      <React.Fragment>
        <div style={titleStyle}> DIRECTORS / COMMITTEE CHAIRS </div>
        <br />
        {dirm.map((dir, bid) =>
        <div key = {bid}>
          <span style={title1Style}> {dir.title} </span><br />
          <span style= {{color: (dir.name === "vacant") ? "red" : "black"}} > {dir.name} </span><br />
        </div>
        )}
      </React.Fragment>
   )}
</React.Fragment>

);
}

export default LoadDir;
